"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const path2DManager = __importStar(require("../internal/path2DManager"));
const Inline_1 = require("./Inline");
const canvases_1 = require("../internal/canvases");
class InlinePath2D extends Inline_1.Inline {
    constructor({ path, width, height, color }) {
        super();
        // このタイミングでないとIEでPath2Dのpolyfillが反映されない
        const Path2D = path2DManager.getPath2D();
        this._path = new Path2D(path);
        this._width = width;
        this._height = height;
        this._color = color;
    }
    width(_arg) {
        return this._width;
    }
    font() {
        return null;
    }
    color() {
        var _a;
        return (_a = this._color) !== null && _a !== void 0 ? _a : null;
    }
    canDraw() {
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onReady(_callback) { }
    draw({ ctx, rect, offset, offsetLeft, offsetRight, offsetTop, offsetBottom, }) {
        offset++;
        const padding = {
            left: offsetLeft,
            right: offsetRight,
            top: offsetTop,
            bottom: offsetBottom,
        };
        ctx.save();
        try {
            ctx.beginPath();
            ctx.rect(rect.left, rect.top, rect.width, rect.height);
            //clip
            ctx.clip();
            //文字描画
            const pos = canvases_1.calcStartPosition(ctx, rect, this._width, this._height, {
                offset,
                padding,
            });
            ctx.translate(pos.x, pos.y);
            ctx.fill(this._path);
        }
        finally {
            ctx.restore();
        }
    }
    canBreak() {
        return false;
    }
    toString() {
        return "";
    }
}
exports.InlinePath2D = InlinePath2D;
